import { Group, Text, UnstyledButton } from "@mantine/core";
import type { Icon } from "@tabler/icons-react";
import { Link } from "react-router";

/**
 * One sidebar entry (Figma "Menu Item"): a 15px outline icon, then the label, with a
 * `gray/1` fill when it's the current page (panel.css).
 */
export function NavItem({
  to,
  label,
  icon: IconComponent,
  active,
  onNavigate,
}: {
  to: string;
  label: string;
  icon: Icon;
  active: boolean;
  onNavigate?: () => void;
}) {
  const body = (
    <Group gap={7} wrap="nowrap" align="flex-start">
      <IconComponent size={15} stroke={1.6} style={{ flexShrink: 0, marginTop: 1.5 }} aria-hidden />
      <Text lh={1.25} c="inherit">
        {label}
      </Text>
    </Group>
  );
  return (
    <UnstyledButton
      component={Link}
      to={to}
      className="sb-nav-item"
      px={5}
      py={10}
      data-active={active || undefined}
      aria-current={active ? "page" : undefined}
      onClick={onNavigate}
    >
      {body}
    </UnstyledButton>
  );
}
